import React, { useState, useEffect } from "react";
import PropTypes from 'prop-types';
import { AUDIO_CONFIG } from '../config/constants';
import "../style.css";

function SettingsPage({ carrierFrequency, setCarrierFrequency, onClose }) {
  const [inputValue, setInputValue] = useState(String(carrierFrequency));

  // Clamp the typed value to the valid range; fall back to the default when
  // the field is empty or not a number
  const commitValue = () => {
    const parsed = Number(inputValue);
    const clamped = (inputValue === '' || isNaN(parsed))
      ? AUDIO_CONFIG.DEFAULT_CARRIER_FREQUENCY
      : Math.min(AUDIO_CONFIG.MAX_CARRIER_FREQUENCY, Math.max(AUDIO_CONFIG.MIN_CARRIER_FREQUENCY, parsed));
    setInputValue(String(clamped));
    setCarrierFrequency(clamped);
  };

  const handleChange = (e) => {
    setInputValue(e.target.value);
    // Apply valid in-range values immediately so a playing beat retunes live
    const parsed = Number(e.target.value);
    if (
      e.target.value !== '' &&
      !isNaN(parsed) &&
      parsed >= AUDIO_CONFIG.MIN_CARRIER_FREQUENCY &&
      parsed <= AUDIO_CONFIG.MAX_CARRIER_FREQUENCY
    ) {
      setCarrierFrequency(parsed);
    }
  };

  const handleClose = () => {
    commitValue();
    onClose();
  };

  // Close the modal when the Escape key is pressed
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape") {
        handleClose();
      }
    };

    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  });

  return (
    <div className="settings-modal">
      <div className="settings-modal-content">
        {/* Close button */}
        <button className="settings-close-x" onClick={handleClose} aria-label="Close">
          ✖
        </button>
        <h1 className="settings-title">Settings</h1>
        <div className="settings-section">
          <label htmlFor="carrier-frequency">Carrier Frequency (Hz):</label>
          <input
            id="carrier-frequency"
            type="number"
            value={inputValue}
            onChange={handleChange}
            onBlur={commitValue}
            min={AUDIO_CONFIG.MIN_CARRIER_FREQUENCY}
            max={AUDIO_CONFIG.MAX_CARRIER_FREQUENCY}
            step="1"
            className="settings-input"
          />
        </div>
        <button onClick={handleClose} className="settings-close-button">
          Save & Close
        </button>
      </div>
    </div>
  );
}

SettingsPage.propTypes = {
  carrierFrequency: PropTypes.number.isRequired,
  setCarrierFrequency: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired
};

export default SettingsPage;
